export default __webpack_public_path__ + "static/media/bookshelf.3507d34d.png";